import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { FluxibleComponent } from 'fluxible-addons-react';
import ActiveUserFlagStore from 'contest/stores/active-user-flag-store';
import OnboardingPromptStore from 'contest/stores/onboarding-prompt-store';
import ContestsActiveUserStore from 'contest/stores/ContestsActiveUserStore';
import ContestStore from 'contest/stores/contest-store';
import ContestFinalistStore from './stores/contest-finalist-store';
import SelectedWinnersStore from './stores/selected-winners-store';
import ModalStore from 'contest/stores/modal-store';
import ContestProductsStore from 'contest/stores/contest-products-store';
import ConnectedSelectWinnerDrawerApp from './components/connected/connected-select-winner-drawer-app';
import ContestFinalistDrawerApp from './components/contest-finalist-drawer-app';
import app from 'contest/data/app';

const context = app.getContext();

const initCommon = () => {
    app.registerStore(ActiveUserFlagStore);
    app.registerStore(ContestStore);
    app.registerStore(OnboardingPromptStore);
    app.registerStore(ContestsActiveUserStore);
    app.registerStore(ModalStore);
    context.getStore(ActiveUserFlagStore).initFromActiveUser(window.activeUser);
    context
        .getStore(ContestStore)
        .init(
            JSON.parse(
                document.querySelector('[data-contest-state]').getAttribute('data-contest-state')
            )
        );
};

const initContestFinalistsDrawerApp = state => {
    initCommon();
    app.registerStore(ContestFinalistStore);
    const store = context.getStore(ContestFinalistStore);
    store.initialise(state);
    store.addChangeListener(store => {
        const nodes = document.querySelectorAll('[data-entry]');
        for (let i = 0; i < nodes.length; ++i) {
            let entry = nodes.item(i);
            let userId = parseInt(entry.getAttribute('data-user-id'), 10);
            if (store.isFinalist(userId)) {
                entry.setAttribute('data-entry-selected', true);
            } else if (entry.hasAttribute('data-entry-selected')) {
                entry.removeAttribute('data-entry-selected');
            }
        }
    });

    return context;
};

const initSelectWinnerDrawerApp = state => {
    initCommon();
    app.registerStore(SelectedWinnersStore);
    app.registerStore(ContestProductsStore);
    const store = context.getStore(SelectedWinnersStore);
    store.initialise(state);
    store.addChangeListener(store => {
        const nodes = document.querySelectorAll('[data-entry]');
        for (let i = 0; i < nodes.length; ++i) {
            let entry = nodes.item(i);
            let designId = parseInt(entry.getAttribute('data-design-id'), 10);
            if (store.isWinner(designId)) {
                entry.setAttribute('data-entry-selected', true);
            } else if (entry.hasAttribute('data-entry-selected')) {
                entry.removeAttribute('data-entry-selected');
            }
        }
    });
    return context;
};

const appTypes = {
    SELECT_FINALISTS: {
        AppComponent: ContestFinalistDrawerApp,
        initContext: initContestFinalistsDrawerApp,
    },
    SELECT_WINNERS: {
        AppComponent: ConnectedSelectWinnerDrawerApp,
        initContext: initSelectWinnerDrawerApp,
    },
};

const entriesApp = (appNode, { appType, state }, intl) => {
    if (!appTypes[appType]) {
        throw `Invalid appType ${appType}`;
    }

    const { AppComponent, initContext } = appTypes[appType];
    const context = initContext(state);

    ReactDOM.render(
        <FluxibleComponent context={context.getComponentContext()}>
            <IntlProvider locale={document.documentElement.lang} messages={intl.messages}>
                <AppComponent />
            </IntlProvider>
        </FluxibleComponent>,
        appNode
    );

    return context;
};

export default entriesApp;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/index.js